import { ValidationErrors, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { FormatRule } from '../_models';

export class CustomValidators {
  static email(control: AbstractControl): ValidationErrors | null {
    const emailError = Validators.email(control);
    if (control.value && emailError) {
      return {'email': {}};
    }

    return null;
  }

  // The pattern and exact length a format rule asks for; whether the value is required is up to the caller
  static formatRule(rule: FormatRule): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    if (rule.pattern) {
      validators.push(Validators.pattern(rule.pattern));
    }

    if (rule.length) {
      validators.push(Validators.minLength(rule.length), Validators.maxLength(rule.length));
    }

    return validators;
  }

  // An empty value passes, so it combines with Validators.required; anything else must be one of the values
  static oneOf(values: (string | number)[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control.value;
      let error: ValidationErrors = null;

      if (value !== null && value !== undefined && value !== '' && values.indexOf(value) === -1) {
        error = { oneOf: true };
      }

      return error;
    };
  }

  // A group validator: at least one of the named controls holds a non-blank value
  static anyRequired(names: string[]): ValidatorFn {
    return (group: AbstractControl): ValidationErrors => {
      const filled = names.some((name) => {
        const control = group.get(name);

        return !!(control && control.value && String(control.value).trim());
      });

      return filled ? null : { anyRequired: true };
    };
  }
}
